import React, { useContext } from 'react';
import styled from 'styled-components';
import { Avatar } from 'antd';
import { ConfigContext } from 'contexts/ConfigContext';

const PackageAuthorContainer = styled.div`
  color: ${props => props.theme.TextColor};
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ant-avatar {
    margin: 0 1rem;
  }

  p {
    margin: 0;
  }
`;

const PackageAuthor = ({ currentPack }) => {

  const { tenantConfig } = useContext(ConfigContext);
  const { CloudFilesContainerUrl } = tenantConfig
  const hasAvatar = currentPack ? currentPack.Booker.CoverGuid !== null : false;

  return currentPack ?
    <PackageAuthorContainer>
      {hasAvatar && <Avatar size={32} src={`${CloudFilesContainerUrl}/${currentPack.Booker.CoverGuid}_c.jpg`} />}
      <p>{currentPack.Booker.Name} {currentPack.Booker.Surname[0]}</p>
    </PackageAuthorContainer>
  : <div />
};

export default PackageAuthor;
